import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { CSS, Style } from './table.style';

addStyles(Style);

export const Table = {
	view(title: string | MithrilVNode, header: MithrilVNode[] | string[], rows: MithrilVNode[][]): MithrilVNode {
		const headerChildren: MithrilVNode[] = [];
		for (const colHeader of header) {
			headerChildren.push(m('th', { className: CSS.MDL.cell }, colHeader));
		}

		const bodyChildren: MithrilVNode[] = [];
		for (const row of rows) {
			const rowChildren: MithrilVNode[] = [];
			for (const col of row) {
				rowChildren.push(m('td', { className: `${CSS.cell} ${CSS.MDL.cell}` }, col));
			}

			bodyChildren.push(m('tr', { className: CSS.row }, rowChildren));
		}

		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.title }, typeof title === 'string' ? m('h6', title) : title),
			m('table', { className: `${CSS.body} ${CSS.MDL.table}` }, [
				m('thead', { className: CSS.header }, headerChildren),
				m('tbody', bodyChildren),
			]),
		]);
	},
};
